import { FaRegHeart } from "react-icons/fa6";
const LocationCard = ({ image, title, text }) => {
  return (
    <div className="location-card">
      <img className="w-100" src={image} alt="" />
      <div className="px-2">
        <div className="d-flex justify-content-between align-items-center my-3">
          <div className="heart-m">
            <FaRegHeart className="heart-icon" />
          </div>
        </div>
        <h1 className="location-b-title">{title}</h1>
        <p className="location-card-text">{text}</p>
        <div className="location-card-border"></div>
      </div>
    </div>
  );
};

export default LocationCard;
